import React from "react"
import { JsonLd } from "react-schemaorg"
import { Organization } from "schema-dts"
import { companyData } from "./data"

const OrganizationJsonLD = () => {
  return (
    <JsonLd<Organization>
      item={{
        "@context": "https://schema.org/" as any,
        "@type": "Organization",
        name: companyData.name,
        // legalName: "",
        image: companyData.cover,
        address: {
          "@type": "PostalAddress",
          streetAddress: companyData.address.street,
          addressLocality: companyData.address.locality,
          addressRegion: companyData.address.region,
          postalCode: companyData.address.postalCode,
        },
        // telephone: "",
      }}
    />
  )
}

export default OrganizationJsonLD
